import React, { useEffect, useContext } from "react";
import { FormContainer as Container, FunctionButton } from "../../components/";
import { useNavigate } from "react-router-dom";
import FormContext from "../../context/FormContext.js";

export default function Form() {
    const navigate = useNavigate();
    const { formData, clearFormData } = useContext(FormContext);

    useEffect(() => {
        if (!localStorage.getItem("SUBMIT")) {
            navigate("/initial-form");
            return;
        }
    }, []);

    const handleRestart = () => {
        clearFormData();
        window.location.reload();
        return;
    }
    return (
        <Container>
            <p className={"justify-center"} style={{
                fontSize: "1.8rem", color: "var(--accent-color)", fontWeight: "500"
            }}>
                Thank you for registering with Good Spirit School Division!
            </p>
            <hr></hr>
            <p style={{ textAlign: "center" }}>Your registration has been received!</p>
            {/* <p style={{ textAlign: "center" }}>We sent a confirmation email to <i>{formData['lafoipSignatureEmail']}</i>.</p> */}
            <br />
            <FunctionButton classNames={"default-btn"} label={"Start New Registration"} onClick={handleRestart}></FunctionButton>


        </Container>
    )
}